import { useIntervalFn, useDocumentVisibility } from '@vueuse/core'

import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { usePingLessonApi } from '../../api/ping-lesson.hook'

interface LessonRoomPingOptions {
  bookingId: number
  onSuccess: (booking: Booking) => void
}

interface LessonRoomPingReturn {
  start: () => void
  stop: () => void
}

const PING_INTERVAL = 5000

export const useLessonRoomPing = ({ bookingId, onSuccess }: LessonRoomPingOptions): LessonRoomPingReturn => {
  const { pingLesson } = usePingLessonApi()
  const visibility = useDocumentVisibility()

  const { pause, resume } = useIntervalFn(async () => {
    if (visibility.value !== 'visible') return

    const booking = await pingLesson(bookingId)
    if (booking) {
      onSuccess(booking)
    }
  }, PING_INTERVAL, { immediate: false })

  return {
    start: resume,
    stop: pause,
  }
}
